import React, { useEffect, useState } from 'react'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { editorConfiguration } from '../../../config/editorConfiguration';
import globalLoading from '../../../redux/reducers/globalLoading';
import { toastError, toastSuccess } from '../../../helpers/toast';
import { editOverview, getOverview } from '../../../app/overviewSlice';

const OverviewEdit = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(['title', 'form', 'sidebar', 'button', 'notiSuccess', 'notiError']);
  const [overviewData, setOverviewData] = useState([]);
  const [countOverview, setCountOverview] = useState(0);
  const [refresh, setRefresh] = useState(Date.now());
  const [onChangeOverview, setOnChangeOverview] = useState('');
  const [onChangeTitle, setOnChangeTitle] = useState('');
  useEffect(() => {
    dispatch(globalLoading.actions.CONTROL_LOADING(true));
    dispatch(getOverview()).then((result) => {
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
      if (result.error && result.payload) {
        toastError(result.payload, 2000)
      }
      if (result.payload.status && result.payload.status === 200) {
        // console.log('getAnnouncement--->', result.payload.data.data.items[0]);
        setOverviewData(result.payload.data.data.items);
        setCountOverview(result.payload.data.data.count);
      }
    }).catch((error) => {
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
      // console.log("error-->", error);
      toastError(error, 2000)
    })
  }, [refresh])
  const handleSubmitFormAdd = () => {
    const inputData = {
      id: countOverview > 0 ? overviewData[countOverview - 1]._id : '',
      title: onChangeTitle,
      content: onChangeOverview
    }
    dispatch(globalLoading.actions.CONTROL_LOADING(true));
    dispatch(editOverview(inputData)).then((result) => {
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
      if (result.error && result.payload) {
        toastError(result.payload, 2000)
      }
      if (result.payload.status && result.payload.status === 200) {
        toastSuccess(t('notiSuccess:overview_edit_success'), 1000);
        setRefresh(Date.now())
      }
    }).catch((error) => {
      dispatch(globalLoading.actions.CONTROL_LOADING(false));
      // console.log("error-->", error);
      toastError(error, 2000)
    })
  }
  return (
    <div id="layoutSidenav_content">
      <main>
        <div className="container-fluid px-4">
          <h1 className="mt-4">
            {t('title:overview')}
          </h1>
          <ol className="breadcrumb mb-4">
            <li className="breadcrumb-item"><Link to='/admin/dashboard'>{t('sidebar:dashboard')}</Link></li>
            <li className="breadcrumb-item active">{t('title:edit_overview')}</li>
          </ol>
          <div className='card mb-4'>
            <div className='card-header'>
              <i className='fas fa-plus me-1'></i>
              {t('title:edit')}
            </div>
            <div className='card-body'>
              <div className='row mb-3'>
                {/* <form onSubmit={handleSubmit(handleSubmitFormAdd)}> */}
                <div className="row justify-content-center text-center">
                  <div className='col-1'>
                    <strong className='form-label'>
                      {t('form:title.title')}
                    </strong>
                  </div>
                  <div className='col-8'>
                    <input onChange={(e) => setOnChangeTitle(e.target.value)} defaultValue={countOverview > 0 ? overviewData[countOverview - 1].title : ''} type='text' className='form-control' placeholder={t('form:place_holder.enter_title')} />
                  </div>
                </div>
                <div className="row mt-4 justify-content-center text-center">
                  <div className='col-1'>
                    <strong htmlFor="noteTextarea1" className='form-label'>
                      {t('form:title.content')}
                    </strong>
                  </div>
                  <div className='col-11'>
                    <CKEditor
                      className="ck-editor_editable_inline"
                      editor={Editor}
                      config={editorConfiguration}
                      data={countOverview > 0 ? overviewData[countOverview - 1].content : ''}
                      onReady={editor => {
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setOnChangeOverview(data);
                      }}
                    />
                  </div>
                </div>
                <div className='row justify-content-end'>
                  <div className='col-2' style={{ marginRight: '10px' }}>
                    <button type='submit' onClick={handleSubmitFormAdd} className='mt-4 btn btn-success btn-set-width'>{t('button:submit')}</button>
                    <Link to={'/admin/dashboard'} style={{ marginLeft: '10px' }} className='mt-4 btn btn-danger btn-set-width' >{t('button:cancel')}</Link>
                  </div>
                </div>
                {/* </form> */}
              </div>
            </div>
          </div>
        </div >
      </main>
    </div>
  )
}

export default OverviewEdit